import React from "react";
import PropTypes from "prop-types";

import StandardLineCharts from "./StandardLineCharts";
import ComponentMissing from "../../Debug/ComponentMissing";

const LineChartsSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  charts,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    charts,
    animation,
  };

  function switchLineCharts() {
    switch (layout) {
      case "standard":
        return <StandardLineCharts properties={properties} />;
      default:
        return <ComponentMissing type="LineCharts" subType={layout} />;
    }
  }

  return switchLineCharts();
};

LineChartsSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  mirrored: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  animation: PropTypes.instanceOf(Object),
};

export default LineChartsSwitcher;
